export type FEATURES_TYPE =
  | "EXAMPLE_FEATURE"
  | "COSTING_OPTIMIZATION"
  | "TRUE_SHAPE_NESTING"
  | "MATERIAL_LIST_IMPORT";

export const Features: Record<FEATURES_TYPE, FEATURES_TYPE> = {
  EXAMPLE_FEATURE: "EXAMPLE_FEATURE",
  COSTING_OPTIMIZATION: "COSTING_OPTIMIZATION",
  TRUE_SHAPE_NESTING: "TRUE_SHAPE_NESTING",
  MATERIAL_LIST_IMPORT: "MATERIAL_LIST_IMPORT",
};
